import ADMIN_PORTAL_LOGO from '@/assets/images/apilogy-logo.png';
import NOT_FOUND_IMAGE from '@/assets/images/404.png';

import { axiosClient } from '@/services/utilities';
import { FaArrowCircleLeft } from 'react-icons/fa';
import Button from '@/components/Button';
import { useNavigate } from 'react-router-dom';
import { userStore } from '@/store/users';
import MainHeader from '@/components/MainHeader';
import { HeaderBar } from '@/components/NavBar/HeaderBar';
import { useEffect, useState } from 'react';
import { frontConfig } from '@/config/front-config';
import { useUserProfile } from '@/hooks/useUserProfile';
import { pageNotFoundStore } from '@/store/pageNotFound';

const config = frontConfig();

const PageNotFound = () => {
  const setIsFrom404Page = pageNotFoundStore((state) => state.setIsFrom404Page);
  const navigate = useNavigate();
  useUserProfile();
  const [userLogedIn] = userStore((state) => [state.userLogedIn]);
  const isLoggedIn = !!userLogedIn?.username;
  console.log(userLogedIn)

  useEffect(() => {
    setIsFrom404Page(true);

    return () => {
      // Reset saat keluar dari halaman
      setIsFrom404Page(false);
    };
  }, []);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const onLoginHandle = async () => {
    try {
      const { data } = await axiosClient.get('/auth/url');
      window.open(data, '_self');
    } catch (error) {
      console.error('Failed to fetch authentication URL', error);
    }
  };

  const logoutHandler = async () => {
    try {
      const { data } = await axiosClient.get(`${config.adminPortalBaseUrl}/auth/logout`);
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('USERNAME');
      window.location = data;
    } catch (err) {
      alert('error logout');
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleMenuClick = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="flex flex-col min-h-screen overflow-hidden">
      {/* Conditional Header */}
      {isLoggedIn ? (
        <HeaderBar
          dropdownOption={[{ title: 'Logout', href: '/logout' }]}
          avatarUrl={userLogedIn?.info?.avatar}
          imageUrl={ADMIN_PORTAL_LOGO}
          onLogoutHandler={logoutHandler}
          onMenuClick={handleMenuClick}
          username={userLogedIn?.username}
          userRole={userLogedIn?.isAdmin ? 'Admin' : ''}
        />
      ) : (
        <MainHeader logo={ADMIN_PORTAL_LOGO} onLogin={onLoginHandle} />
      )}

      {/* 404 Content */}
      <div className="flex flex-col items-center justify-center px-4 mt-10">
        <img
          src={NOT_FOUND_IMAGE}
          alt="Page Not Found"
          className="w-full max-w-md mb-8"
        />

        <h1 className="mb-4 text-2xl font-bold text-center text-black md:text-4xl">
          Page Not Found
        </h1>
        <p className="mb-6 text-sm text-center text-black md:text-base opacity-60">
          The page you are looking for might have been removed or is temporarily unavailable.
        </p>

        <div className="flex justify-center w-full md:w-auto">
          <Button
            onClick={handleGoBack}
            iconLeft={<FaArrowCircleLeft size={18} />}
          >
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
